$(function () {
	var channelSlide = $('.channel-slide .slide')
	var channelSlideNum = channelSlide.size()
	var channelPagnation = $('.channel-slide .pagnation')
	var channelSlidePrev = $('.channel-slide .prev')
	var channelSlideNext = $('.channel-slide .next')
	var channelPagnationIndex = 0
	var channelSlideDelay = 600
	var channelSlideAutoPlayTime = 4000
	var channelSlideTimerId = null
	// pagnation
	for (var i = 0; i < channelSlideNum; i++) {
		if (i === 0) {
			channelPagnation.append('<span class="current"></span>')
		} else {
			channelPagnation.append('<span></span>')
		}
	}
	var channelPagnationWidth = channelPagnation.outerWidth()
	channelPagnation.css('marginLeft', -channelPagnationWidth / 2)
	channelPagnation.children('span').mouseover(function () {
		var channelPagnationIndex = $(this).index()
		$(this).addClass('current').siblings().removeClass('current')
		channelSlide
			.fadeOut(channelSlideDelay)
			.eq(channelPagnationIndex)
			.fadeIn(channelSlideDelay)
	})
	// prev
	function ChannelSlidePrevPlay() {
		channelPagnationIndex--
		channelPagnationIndex = channelPagnationIndex % channelSlideNum
		channelSlide
			.fadeOut(channelSlideDelay)
			.eq(channelPagnationIndex)
			.fadeIn(channelSlideDelay)
		channelPagnation
			.children('span')
			.eq(channelPagnationIndex)
			.addClass('current')
			.siblings()
			.removeClass('current')
	}
	// next
	function ChannelSlideNextPlay() {
		channelPagnationIndex++
		channelPagnationIndex = channelPagnationIndex % channelSlideNum
		channelSlide
			.fadeOut(channelSlideDelay)
			.eq(channelPagnationIndex)
			.fadeIn(channelSlideDelay)
		channelPagnation
			.children('span')
			.eq(channelPagnationIndex)
			.addClass('current')
			.siblings()
			.removeClass('current')
	}
	// autoplay
	channelSlideTimerId = setInterval(
		ChannelSlideNextPlay,
		channelSlideAutoPlayTime
	)

	$('.channel-slide').hover(
		function () {
			clearInterval(channelSlideTimerId)
		},
		function () {
			channelSlideTimerId = setInterval(
				ChannelSlideNextPlay,
				channelSlideAutoPlayTime
			)
		}
	)
	channelSlidePrev.click(function () {
		ChannelSlidePrevPlay()
	})
	channelSlideNext.click(function () {
		ChannelSlideNextPlay()
	})

	$('.show-tab').listenForm({
		siteId: 6,
		contentName: '国际学校入学考试测评',
		submitTarget: '#submitBtn1',
		courseRequired: true,
		cityRequired: true,
	})
})
